// Section-level governance intro. Renders an <h2> (page H1 lives in the About hero).
export function GovernanceHero({ eyebrow, heading, intro }) {
  return (
    <div className="max-w-3xl" data-testid="governance-hero">
      <p className="eyebrow mb-5">{eyebrow}</p>
      <h2 className="font-display font-bold text-navy leading-[1.05]" style={{ fontSize: "clamp(2rem,3.6vw,3.1rem)" }}>
        {heading}
      </h2>
      <p className="mt-6 text-[var(--mineral)]" style={{ fontSize: "clamp(1.05rem,1.4vw,1.2rem)", lineHeight: 1.7 }}>
        {intro}
      </p>
    </div>
  );
}
